import ReportDemographics from './ReportDemographics';
export default ReportDemographics;
